import React from "react";
import ProtectionFailureIcon from "../../assets/img/protectionChannelSubmissionFailed.svg";
import Translation from "../../services/translation.service";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";

export default function ProtectionChannelStatusFailure({
  setStepDetails = () => {},
  setActiveScreen = () => {},
  setStatus = () => {},
}) {
  let prefix = "scr_protection_channel";

  const contactUsRedirect = () => {
    clearStorage();
    let contact_us_link = Settings.get("contact_us");
    contact_us_link = contact_us_link.replace("%lang%", Translation.activeLang);
    window.location.href = contact_us_link;
  };

  const clearStorage = () => {
    window.localStorage.removeItem("protection_channel_redirect");
    window.localStorage.removeItem("protection_channel_redirect_url");
    window.localStorage.removeItem("protection_channel_step");
    Storage.clear("reportErrorStatus", true, true);
    Storage.clear("reportOtpError", true, true);
  };

  const tryhandling = () => {
    Storage.clear("reportErrorStatus", true, true);
    Storage.clear("reportOtpError", true, true);
    setStepDetails({
      step1: { status: "isDone" },
      step2: { status: "inProgress" },
      step3: { status: "notVisited" },
    });
    setActiveScreen("ReasonScreen");
    setStatus("");
  };

  return (
    <div className="root-survey-330-form">
      <div className="form-container">
        <div className="form-submission-outcome">
          <img src={ProtectionFailureIcon} alt="Outcome icon" />
          <div className="title">
            {Translation.keys[prefix + "_submit_report_failure_text"]}
          </div>
          <div className="description">
            {Translation.keys[prefix + "_submit_report_failure_subtext"]}
          </div>

          <button
            className="common-button"
            onClick={() => {
              tryhandling();
            }}
          >
            {Translation.keys[prefix + "_tryagain"]}
          </button>
          <div className="close" 
            onClick={() => {
              contactUsRedirect();
            }}
          >
            {Translation.keys[prefix + "_contact_us"]}
          </div>
        </div>
      </div>
    </div>
  );
}
